// extracted by mini-css-extract-plugin
export default {"title":"style_title__3eFjT","submit":"style_submit__rbj-D","buttons":"style_buttons__1EEwi","avatar":"style_avatar__yc7qc"};